import { format } from 'date-fns'
import * as mime from 'mime-types'
import { GeckoFileCategory, GeckoReportJSON } from 'types'
import { REPORT_ENTRY_UPLOAD_DATE_FORMAT } from 'utils/constants'

export function createGeckoReportData({
  file,
  fileCategory,
  units,
  components,
  jobs,
  inspections,
  vizInspFieldResponses,
  visualInspections,
  fileSource,
  documentDate,
}: {
  file: File
  fileCategory: GeckoFileCategory
  units?: string[]
  components?: string[]
  jobs?: string[]
  inspections?: string[]
  vizInspFieldResponses?: string[]
  visualInspections?: string[]
  fileSource?: string
  documentDate?: string
}): GeckoReportJSON {
  return {
    visible_name: file.name,
    file_type: mime.extension(file.type),
    upload_date: format(Date.now(), REPORT_ENTRY_UPLOAD_DATE_FORMAT),
    size: file.size,
    units: units ?? [],
    components: components ?? [],
    inspections: inspections ?? [],
    jobs: jobs ?? [],
    file_category: fileCategory,
    ...(documentDate !== undefined && { document_date: documentDate }),
    ...(fileSource !== undefined && { file_source: fileSource }),
    ...(vizInspFieldResponses !== undefined && {
      viz_insp_field_responses: vizInspFieldResponses,
    }),
    ...(visualInspections !== undefined && {
      visual_inspections: visualInspections,
    }),
  }
}
